export default {
  pipedrive_api : 'https://zonnefabriek.pipedrive.com/v1/',
  pipedrive_api_token : '1a8a7816269f92db3d8db4ba1a309d4685847d1c',
  wp_api : (process.env.NODE_ENV == 'development' 
      ? 'https://huurdezon.bwhontwerpers.nl' 
      : 'https://huurdezon.nl'
    ),
}
